import type { TOC } from '@ember/component/template-only';
import { PrismButton, PrismCard } from '@mylighthouse/prism-ember';
import { t } from 'ember-intl';
import { not } from 'ember-truth-helpers';
import SettingsMyotbCredentials from 'lumen/components/settings/myotb/credentials';
import SettingsMyotbOtbSelfServiceDataBar from 'lumen/components/settings/myotb/otb-self-service-data-bar';
import SettingsMyotbStepItem from 'lumen/components/settings/myotb/step-item';
import type HotelSettingsMyotbPmsSetupController from 'lumen/controllers/hotel/settings/myotb/pms-setup';

interface HotelSettingsMyotbPmsSetupSignature {
  Args: {
    controller: HotelSettingsMyotbPmsSetupController;
    model: unknown;
  };
}

<template>
  <PrismCard
    class="myotb-card"
    data-test-id="hotel-settings-myotb-pms-setup-card"
  >
    <:header as |Header|>
      <div class="grid gap-400">
        <SettingsMyotbOtbSelfServiceDataBar />
        <Header.title>
          {{t
            "settings.my_otb.steps.title"
            pmsOrOtherSystemName=@controller.pmsOrOtherSystemName
          }}
        </Header.title>
      </div>
    </:header>

    <:content>
      <div class="myotb-card__content-container flex flex-col gap-400">
        <p class="paragraph-300--regular">{{t
            "settings.my_otb.steps.intro"
          }}</p>

        <div class="flex flex-col gap-200">
          {{#each @controller.setupSteps as |setupStep|}}
            <SettingsMyotbStepItem
              @answer={{setupStep.answer}}
              @helpText={{setupStep.helpText}}
              @helpUrl={{setupStep.helpUrl}}
              @name={{setupStep.name}}
              @order={{setupStep.order}}
              @setAnswer={{@controller.setAnswerTask}}
              @stepType={{setupStep.stepType}}
            />
          {{/each}}
        </div>

        <SettingsMyotbCredentials />
      </div>
    </:content>

    <:footer>
      <div class="flex justify-between gap-300">
        <PrismButton
          @buttonType="ghost"
          @iconBefore="arrow-left"
          @label={{t "general.back"}}
          @onClick={{@controller.onClickPrevious}}
        />
        <PrismButton
          @iconAfter="arrow-right"
          @isDisabled={{not @controller.isContinueEnabled}}
          @label={{t "general.continue"}}
          @onClick={{@controller.onClickContinue}}
        />
      </div>
    </:footer>
  </PrismCard>
</template> satisfies TOC<HotelSettingsMyotbPmsSetupSignature>;
